import { AddressContact } from "../models/get-address-response";
import { clientConfig } from "../constant/app.constant";

function isReturnableFromTags(tags?: string[]): boolean {
  if (!tags || !tags.length) return true;

  const normalizedTags = tags.map((t) => t.trim().toLowerCase());
  const nonReturnableTags = ["newmessage: final sale - no refunds & exchanges", "clearance", "final sale"];

  return !normalizedTags.some((tag) => nonReturnableTags.includes(tag));
}

export function getOrderDataFromShopifyOrder(shopifyOrder: any, merchantId: string) {
  return {
    merchantId,
    tenantId: null,
    returnCenterId: clientConfig.RETURN_CENTER_ID,
    redirectUri: null,
    cancelUri: null,
    errorUri: null,
    postBackURL: null,
    postBackToken: null,
    orders: [
      {
        orderNumber: shopifyOrder.name.startsWith("#") ? shopifyOrder.name.slice(1) : shopifyOrder.name,
        orderDate: shopifyOrder.createdAt,
        orderAddress: {
          name: shopifyOrder.shippingAddress?.name,
          streetAddress: shopifyOrder.shippingAddress?.address1,
          streetAddressHouseNumber: "",
          additionalAddressInformation: shopifyOrder.shippingAddress?.address2,
          city: shopifyOrder.shippingAddress?.city,
          isoCountry: shopifyOrder.shippingAddress?.countryCode,
          state: shopifyOrder.shippingAddress?.provinceCode,
          zipcode: shopifyOrder.shippingAddress?.zip,
          email: shopifyOrder.email,
          contactInfo: {
            firstName: shopifyOrder.shippingAddress?.name,
            lastName: null,
            email: shopifyOrder.email,
            phone: shopifyOrder.shippingAddress?.phone,
          },
          longitude: null,
          latitude: null,
          residential: false,
          vatNumber: "",
        },
        returnToAddress: null,
        orderLines: shopifyOrder.lineItems.edges.map((item, idx) => ({
          internalIdentifier: idx + 1,
          lineNumber: idx.toString(),
          itemName: item.node.name,
          itemNumber: item.node.sku,
          assessmentId: null,
          description: "",
          returnableQuantity: item.node.quantity,
          returnableQuantityUnitOfMeasure: item?.node?.variant?.inventoryItem?.measurement?.weight?.unit || "",
          brand: "",
          size: item.node.variant.title,
          color: "",
          unitPrice: parseFloat(item.node.originalUnitPriceSet.shopMoney.amount),
          weight: item?.node?.variant?.inventoryItem?.measurement?.weight?.value || 0,
          volume: 0,
          currency: item.node.originalUnitPriceSet.shopMoney.currencyCode,
          returnInstructions: null,
          deliveryDate: null,
          returnable: true,
          tagBasedReturnable: isReturnableFromTags(item?.node?.variant?.product?.tags),
          selectedForReturn: false,
          returnReason: null,
          quantityToReturn: 0,
          originCode: item.node.variant.inventoryItem.countryCodeOfOrigin,
          lotNumber: null,
          expirationDate: null,
          serialNumbers: null,
          expectedSerials: null,
          pickupDate: null,
          height: 0,
          heightUnitOfMeasure: null,
          length: 0,
          lengthUnitOfMeasure: null,
          width: 0,
          widthUnitOfMeasure: null,
          countryOfOrigin: item.node.variant.inventoryItem.countryCodeOfOrigin || null,
          hsCode: Number(item.node.variant.inventoryItem.harmonizedSystemCode) || 0,
        })),
        currency: shopifyOrder.totalPriceSet.shopMoney.currencyCode,
        deductionRate: null,
        referenceField1: null,
        referenceField2: null,
        referenceField3: null,
        referenceField4: null,
        referenceField5: null,
        modeOfTransport: null,
        rmaNumber: null,
        brandInfo: null,
        customs: null,
      },
    ],
    hasCarrierCancelled: null,
    cancelOrderExpiry: null,
    carrierInfo: {
      carrier: null,
      carrierService: null,
    },
  };
}
